import { inject, Injectable } from '@angular/core';
import { TourService } from 'ngx-ui-tour-md-menu';
import { AuthService } from '../../auth/auth.service';
import { BaseService } from './base.service';
import { MatDialog } from '@angular/material/dialog';
import { BranchBusinessSetupDialogComponent } from '../components/branch-business-setup-dialog/branch-business-setup-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class GuidelineService {
  public tourService = inject(TourService);
  private dialog = inject(MatDialog);
  private isFirstTime = false;

  constructor(
    private _auth: AuthService,
    private _base: BaseService
  ) {
    this.tourService.initialize([{
      anchorId: 'header.first',
      content: 'GUIDE.HEADER_STEP_1_DESC',
      title: 'GUIDE.HEADER_STEP_1'
    }, {
      anchorId: 'header.second',
      content: 'GUIDE.HEADER_STEP_2_DESC',
      title: 'GUIDE.HEADER_STEP_2',
    }, {
      anchorId: 'side.first',
      content: 'GUIDE.MANAGE_ACCOUNT_DESC',
      title: 'GUIDE.MANAGE_ACCOUNT'
    }
      , {
      anchorId: 'side.second',
      content: 'GUIDE.WORK_AREAS_DESC',
      title: 'GUIDE.WORK_AREAS'
    }
      , {
      anchorId: 'side.support',
      content: 'GUIDE.CUSTOMER_SUPPORT_DESC',
      title: 'GUIDE.CUSTOMER_SUPPORT'
    }
    ], {
      enableBackdrop: true,
      nextBtnTitle: 'GUIDE.NEXT',
      prevBtnTitle: 'GUIDE.PREV',
      endBtnTitle: 'GUIDE.END',
      backdropConfig: {
        offset: 10,
      },
    });
  }

  start(firstTime = false) {
    this.isFirstTime = firstTime;
    this.tourService.start();
    this._base.sideNave.next("open")
  }

  end() {
    this.tourService.end();
    if (this.isFirstTime) {
      this._auth.disableGuide().subscribe((res) => {
        const currentUser = JSON.parse(localStorage.getItem('CURRENT_USER'));
        currentUser.showTutorialGuide = false;
        localStorage.setItem('CURRENT_USER', JSON.stringify(currentUser));
        console.log(res);
        this.openBranchBusinessSetupDialog();
      });
    }
    this.isFirstTime = false;
  }

  private openBranchBusinessSetupDialog(): void {
    const branches = JSON.parse(localStorage.getItem('CUSTOMER_BRANCHES') || '[]');
    if (branches.length === 0) return;

    const branch = branches[0];
    const hasServices = branch.services && branch.services.length > 0;
    if (hasServices) return;

    this.dialog.open(BranchBusinessSetupDialogComponent, {
      width: '700px',
      maxWidth: '90vw',
      maxHeight: '85vh',
      disableClose: true,
      autoFocus: false
    });
  }
}
